import {BaseModel} from "../../base/models/base-model.model";
import {DraftsResearchFilterModel} from "./drafts-research-filter.model";
import {DraftsResearchFilter1Model} from "./drafts-research-filter1.model";

export class DraftsResearchModel extends BaseModel {
  private _filter: DraftsResearchFilterModel;
  private _options?: DraftsResearchFilter1Model;

  constructor(filter?: DraftsResearchFilterModel, options?: DraftsResearchFilter1Model) {
    super();
    this._filter = filter;
    this._options = options;
  }

  get filter(): DraftsResearchFilterModel {
    return this._filter;
  }

  set filter(value: DraftsResearchFilterModel) {
    this._filter = value;
  }

  get options(): DraftsResearchFilter1Model {
    return this._options;
  }

  set options(value: DraftsResearchFilter1Model) {
    this._options = value;
  }
}
